// @flow

import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { parseJWT } from 'helpers';
import { fromJS } from 'immutable';
import { ChevronUp, ChevronDown } from '../../components/Icons';
import ConfigCustomCheckbox from 'components/ConfigCustomCheckbox';
import { Container, Row, Col, Alert, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import colors from 'styles/colors';
import AsyncSelect from 'react-select';
import NotifCourriel from './styles';
import Loader from 'components/Loader';

import Grid from '@mui/material/Grid';
// Selectors
import {
    selectEmailsRecords,
    selectEmailNotifConfigRecords,
    selectEmailsLoading,
    selectSaveConfig,
} from 'services/Config/selectors';
import { selectUser } from 'services/Authentication/selectors';
//THUNKS
import {
    getEmailsByBranchId,
    getEmailNotifConfigByEquipementId,
    setNotificationCopy,
    setSavingConfig,
    editNotifCourriel,
} from 'services/Config/thunks';
// Defaults
const voltagesoptions = [...Array(160)].fill().map((v, i) => [i / 10, i * 100]);
const voltagesoptionsGeoMobile = [...Array(31)].fill().map((_, i) => {
    const voltage = 3.5 + i * 0.01;
    return [parseFloat(voltage.toFixed(2)), Math.round(voltage * 1000)];
});
function NotificationConfig(props) {
    const tempoptions = [
        {
            value: 'Aux2Temperature',
            label: `${props.intl.formatMessage({
                id: 'components.Modals.Form.Config.Notif.Temp',
            })} (Aux2)`,
            key: 'aux2Enabled',
        },
        {
            value: 'Aux3Temperature',
            label: `${props.intl.formatMessage({
                id: 'components.Modals.Form.Config.Notif.Temp',
            })} (Aux3)`,
            key: 'aux3Enabled',
        },
        {
            value: 'Aux4Temperature',
            label: `${props.intl.formatMessage({
                id: 'components.Modals.Form.Config.Notif.Temp',
            })} (Aux4)`,
            key: 'aux4Enabled',
        },
    ];

    const auxoptions = [
        { value: 'Aux1', label: 'Aux1', key: 'sendEventOnAux1' },
        { value: 'Aux2', label: 'Aux2', key: 'sendEventOnAux2' },
        { value: 'Aux3', label: 'Aux3', key: 'sendEventOnAux3' },
        { value: 'Aux4', label: 'Aux4', key: 'sendEventOnAux4' },
    ];
    const [detailed, setDetailed] = useState(true);
    const [buttonChecked, setButtonChecked] = useState(false);
    const [selectedOptiontemp, setSelectedOptiontemp] = useState([]);
    const [selectedOptionaux, setSelectedOptionaux] = useState([]);
    const [emails, setEmails] = useState([]);
    const [batteryVoltage, setBatteryVoltage] = useState(0);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [Accelerometer, setAccelerometer] = useState(false);
    const [Battery, setBattery] = useState(false);
    const [KeyOn, setKeyOn] = useState(false);
    const [radioDisabled, setRadioDisabled] = useState(true);
    const [notifRecords, setNotifRecords] = useState([]);
    const [KeyOff, setKeyOff] = useState(false);
    const [UnauthorizedMove, setUnauthorizedMove] = useState(false);
    const [Stolen, setStolen] = useState(false);
    const [StolenEnd, setStolenEnd] = useState(false);
    const [MotorIdle, setMotorIdle] = useState(false);
    const [Speed, setSpeed] = useState(false);
    const [Geofence, setGeofence] = useState(false);
    const [Button, setButton] = useState(false);
    const [PlugEvent, setPlugEvent] = useState(false);
    const [UnplugEvent, setUnplugEvent] = useState(false);
    const tempoptionsFiltered = useMemo(
        () =>
            tempoptions.filter((value) => {
                switch (value.key) {
                    case 'aux2Enabled':
                        return props.settingsRecords.getIn(['temperatureReading', 'aux2Enabled']);
                    case 'aux3Enabled':
                        return props.settingsRecords.getIn(['temperatureReading', 'aux3Enabled']);
                    case 'aux4Enabled':
                        return props.settingsRecords.getIn(['temperatureReading', 'aux4Enabled']);
                    default:
                        return true;
                }
            }),
        [props.settingsRecords]
    );

    const auxoptionsFiltered = useMemo(
        () =>
            auxoptions.filter((value) => {
                switch (value.key) {
                    case 'sendEventOnAux1':
                        return props.settingsRecords.getIn(['inputManagement', 'sendEventOnAux1']);
                    case 'sendEventOnAux2':
                        return props.settingsRecords.getIn(['inputManagement', 'sendEventOnAux2']);
                    case 'sendEventOnAux3':
                        return props.settingsRecords.getIn(['inputManagement', 'sendEventOnAux3']);
                    case 'sendEventOnAux4':
                        return props.settingsRecords.getIn(['inputManagement', 'sendEventOnAux4']);
                    default:
                        return true;
                }
            }),
        [props.settingsRecords]
    );

    const aux2Enabled = props.settingsRecords.getIn(['temperatureReading', 'aux2Enabled']);
    const aux3Enabled = props.settingsRecords.getIn(['temperatureReading', 'aux3Enabled']);
    const aux4Enabled = props.settingsRecords.getIn(['temperatureReading', 'aux4Enabled']);

    const sendEventOnAux1 = props.settingsRecords.getIn(['inputManagement', 'sendEventOnAux1']);
    const sendEventOnAux2 = props.settingsRecords.getIn(['inputManagement', 'sendEventOnAux2']);
    const sendEventOnAux3 = props.settingsRecords.getIn(['inputManagement', 'sendEventOnAux3']);
    const sendEventOnAux4 = props.settingsRecords.getIn(['inputManagement', 'sendEventOnAux4']);

    const antitheftalarmDisabled = props.settingsRecords.getIn(['antitheft', 'alarmDisabled']);
    const speedDetectionEnabled = props.settingsRecords.get('speedDetectionEnabled');
    useEffect(
        async () => {
            const jwt = parseJWT(props.user.get('token'));
            const branchId = jwt['https://geothentic.com/branch_id'];
            await getEmailsByBranchId(branchId);
        },
        [getEmailsByBranchId]
    );
    useEffect(
        () => {
            if (!props.equipementId) return;
            getEmailNotifConfigByEquipementId(props.equipementId);
        },
        [props.equipementId]
    );
    useEffect(
        () => {
            if (props.notifRecords && props.notifRecords.size > 0) {
                const voltageFromProps = props.notifRecords.get('batteryVoltage');
                const defaultBatteryVoltage =
                    props.equipementType === 'bewhere' && !voltageFromProps
                        ? 3500
                        : voltageFromProps;
                setBatteryVoltage(defaultBatteryVoltage);
                setNotifRecords(props.notifRecords.get('notifications'));
            }
        },
        [props.notifRecords]
    );
    useEffect(
        () => {
            if (props.emails && props.emails.size > 0) {
                setEmails(props.emails);
            }
        },
        [props.emails]
    );
    useEffect(
        () => {
            if (props.saveConfig) {
                props.setSavingConfig(false);
                props.editNotifCourriel(props.equipementId, getChangedItems(), props);
            }
        },
        [props.saveConfig]
    );
    // Equivalent to `getChangedItems`
    const getChangedItems = useCallback(
        () => ({
            notifications: notifRecords.toJS(),
            batteryVoltage,
        }),
        [notifRecords, batteryVoltage]
    );

    const updateAsyncSelectInArray = useCallback(
        (array, selectedOption, selectedEmail, isTemp) => {
            // this case the selected email does not exist in state
            if (array.findIndex((i) => i.get('emailId') == selectedEmail) === -1) {
                const events = selectedOption.map((item) => item.value);
                const newEntry = fromJS({
                    emailId: Number(selectedEmail),
                    vehicleId: Number(props.equipementId),
                    events,
                });
                return array.push(newEntry);
            }

            return array.map((item) => {
                if (selectedEmail !== item.get('emailId')) return item;

                const cleanedEvents = item.get('events').filter((o) => {
                    return isTemp
                        ? !(o.startsWith('Aux') && o.length === 15)
                        : !(o.startsWith('Aux') && o.length === 4);
                });

                const newEvents = [...cleanedEvents, ...selectedOption.map((val) => val.value)];
                return item.set('events', newEvents);
            });
        },
        [props.equipementId]
    );

    const handleChangetemp = useCallback(
        async (selectedOptiontemp) => {
            const updatedNotif = updateAsyncSelectInArray(
                notifRecords,
                selectedOptiontemp,
                selectedEmail,
                true
            );
            setSelectedOptiontemp(selectedOptiontemp);
            setNotifRecords(updatedNotif);
            await props.handleChange(getChangedItems());
        },
        [notifRecords, selectedEmail, updateAsyncSelectInArray, props, getChangedItems]
    );

    const handleChangeaux = useCallback(
        async (selectedOptionaux) => {
            const updatedNotif = updateAsyncSelectInArray(
                notifRecords,
                selectedOptionaux,
                selectedEmail,
                false
            );
            setSelectedOptionaux(selectedOptionaux);
            setNotifRecords(updatedNotif);
            await props.handleChange(getChangedItems());
        },
        [notifRecords, selectedEmail, updateAsyncSelectInArray, props, getChangedItems]
    );

    const updateObjectInArray = useCallback(
        (array, action, targetid, selectedEmail) => {
            const index = array.findIndex((i) => i.get('emailId') === Number(selectedEmail));
            if (index === -1) {
                const newEntry = fromJS({
                    emailId: Number(selectedEmail),
                    vehicleId: Number(props.equipementId),
                    events: [targetid],
                });
                return array.push(newEntry);
            }

            return array.map((item) => {
                if (Number(selectedEmail) !== item.get('emailId')) return item;
                const currentEvents = item.get('events');
                return action
                    ? item.set('events', [...currentEvents, targetid])
                    : item.set('events', currentEvents.filter((o) => o !== targetid));
            });
        },
        [props.equipementId]
    );

    const updateCheckBox = useCallback(
        async (e) => {
            const checked = e.target.checked;
            const id = e.target.id;
            console.log('id', id);
            const updatedNotif = updateObjectInArray(notifRecords, checked, id, selectedEmail);

            // Dynamically update state for that checkbox
            switch (id) {
                case 'Accelerometer':
                    setAccelerometer(checked);
                    break;
                case 'Battery':
                    setBattery(checked);
                    break;
                case 'KeyOn':
                    setKeyOn(checked);
                    break;
                case 'KeyOff':
                    setKeyOff(checked);
                    break;
                case 'UnauthorizedMove':
                    setUnauthorizedMove(checked);
                    break;
                case 'Stolen':
                    setStolen(checked);
                    break;
                case 'StolenEnd':
                    setStolenEnd(checked);
                    break;
                case 'MotorIdle':
                    setMotorIdle(checked);
                    break;
                case 'Speed':
                    setSpeed(checked);
                    break;
                case 'Geofence':
                    setGeofence(checked);
                    break;
                case 'Button':
                    setButton(checked);
                    break;
                case 'PlugEvent':
                    setPlugEvent(checked);
                    break;
                case 'UnplugEvent':
                    setUnplugEvent(checked);
                    break;
                default:
                    break;
            }

            setNotifRecords(updatedNotif);
            await props.handleChange(getChangedItems());
        },
        [notifRecords, selectedEmail, updateObjectInArray, props, getChangedItems]
    );

    const resetItems = useCallback((id) => {
        setSelectedEmail(id);
        setRadioDisabled(false);
        setAccelerometer(false);
        setBattery(false);
        setKeyOn(false);
        setKeyOff(false);
        setUnauthorizedMove(false);
        setStolen(false);
        setStolenEnd(false);
        setMotorIdle(false);
        setSpeed(false);
        setGeofence(false);
        setButton(false);
        setPlugEvent(false);
        setUnplugEvent(false);
        setSelectedOptionaux([]);
        setSelectedOptiontemp([]);
    }, []);

    const handleSelectedEmail = useCallback(
        (e) => {
            const id = e.target.id;
            resetItems(id);

            notifRecords.map((item) => {
                if (item.get('emailId') == id) {
                    const auxOpts = [];
                    const tempOpts = [];

                    item.get('events').forEach((value) => {
                        if (value.startsWith('Aux')) {
                            if (value.includes('Temperature')) {
                                const match = tempoptions.find((obj) => obj.value === value);
                                if (match) tempOpts.push(match);
                            } else {
                                const match = auxoptions.find((obj) => obj.value === value);
                                if (match) auxOpts.push(match);
                            }
                        } else {
                            switch (value) {
                                case 'Accelerometer':
                                    setAccelerometer(true);
                                    break;
                                case 'Battery':
                                    setBattery(true);
                                    break;
                                case 'KeyOn':
                                    setKeyOn(true);
                                    break;
                                case 'KeyOff':
                                    setKeyOff(true);
                                    break;
                                case 'UnauthorizedMove':
                                    setUnauthorizedMove(true);
                                    break;
                                case 'Stolen':
                                    setStolen(true);
                                    break;
                                case 'StolenEnd':
                                    setStolenEnd(true);
                                    break;
                                case 'MotorIdle':
                                    setMotorIdle(true);
                                    break;
                                case 'Speed':
                                    setSpeed(true);
                                    break;
                                case 'Geofence':
                                    setGeofence(true);
                                    break;
                                case 'Button':
                                    setButton(true);
                                    break;
                                // Add additional fields here
                                default:
                                    break;
                            }
                        }
                    });

                    setSelectedOptionaux(auxOpts);
                    setSelectedOptiontemp(tempOpts);
                }
            });
        },
        [notifRecords, tempoptions, auxoptions, resetItems]
    );

    const handleCheckboxChange = (e) => {
        if (e.target.checked) {
            props.setNotificationCopy(true);
            setButtonChecked(true);
        } else {
            props.setNotificationCopy(false);
            setButtonChecked(false);
        }
    };
    useEffect(
        () => {
            if (!props.user.get('token')) return;
            const jwt = parseJWT(props.user.get('token'));
            const branchId = jwt['https://geothentic.com/branch_id'];
            props.getEmailsByBranchId(branchId);
        },
        [props.user]
    );

    useEffect(
        () => {
            if (props.checked) {
                setButtonChecked(true);
                props.setNotificationCopy(true);
            } else {
                setButtonChecked(false);
                props.setNotificationCopy(false);
            }
        },
        [props.checked]
    );
    return (
        <Grid
            container
            sx={{
                border: 'solid 1px #B6C2E2',
                alignContent: 'flex-start',
                boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.2)',
                padding: '20px',
                borderRadius: '7px',
                overflowY: 'scroll',
                height:'fit-content',
            }}
        >
            <Grid
                xs={12}
                sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    padding: '2px 0 0 0',
                    alignItems: 'center',
                }}
            >
                {detailed ? (
                    <div onClick={() => setDetailed(false)}>
                        <ChevronUp />
                    </div>
                ) : (
                    <div onClick={() => setDetailed(true)}>
                        <ChevronDown />
                    </div>
                )}

                <span className={'economieHeader'}>Notification par courriel</span>
                {props.step === 1 && (
                    <ConfigCustomCheckbox
                        checked={buttonChecked}
                        onChange={(e) => handleCheckboxChange(e)}
                    />
                )}
            </Grid>
            {detailed ? (
                <React.Fragment>
                    <Grid xs={12}>
                        <hr style={{ border: 'none', height: '1px', backgroundColor: '#B6C2E2' }} />
                    </Grid>
                    <Container style={{display:'block', width:'100%'}}>
                        <Loader loading={props.loading} />
                        {emails.size > 0 && !props.loading ? (
                            <Row>
                                <Col md="4" style={{ paddingBottom: '1rem' }}>
                                    <NotifCourriel.ScrollBox>
                                        {emails
                                            .sort((a, b) => {
                                                const nameA = a.get('emailAddress');
                                                const nameB = b.get('emailAddress');
                                                if (nameA < nameB) return -1;
                                                if (nameA > nameB) return 1;
                                                return 0;
                                            })
                                            .map((item, index) => (
                                                <div
                                                    style={{
                                                        display: 'block',
                                                        height: '30px',
                                                        lineHeight: '30px',
                                                        width: '100%',
                                                    }}
                                                    key={index}
                                                >
                                                    <Form.Check
                                                        style={{ paddingLeft: '2rem' }}
                                                        type="radio"
                                                        label={item.get('emailAddress')}
                                                        name="notificationEmailsRadiobox"
                                                        id={item.get('id')}
                                                        onClick={handleSelectedEmail}
                                                    />
                                                </div>
                                            ))}
                                    </NotifCourriel.ScrollBox>
                                </Col>
                                {props.equipementType === 'GEOMETRIS' ? (
                                    <Col md="4">
                                        <Row>
                                            <Col>
                                                <Form.Check
                                                    inline
                                                    label={props.intl.formatMessage({
                                                        id:
                                                            'components.Modals.Form.Config.Notif.Demarrage',
                                                    })}
                                                    id="KeyOn"
                                                    onClick={updateCheckBox}
                                                    checked={KeyOn}
                                                    disabled={radioDisabled}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Check
                                                    inline
                                                    label={props.intl.formatMessage({
                                                        id:
                                                            'components.Modals.Form.Config.Notif.Arret',
                                                    })}
                                                    disabled={radioDisabled}
                                                    onClick={updateCheckBox}
                                                    checked={KeyOff}
                                                    id="KeyOff"
                                                />
                                            </Col>
                                        </Row>
                                        {speedDetectionEnabled && (
                                            <Row>
                                                <Col>
                                                    <Form.Check
                                                        inline
                                                        label={props.intl.formatMessage({
                                                            id:
                                                                'components.Modals.Form.Config.Notif.DepVitesse',
                                                        })}
                                                        disabled={radioDisabled}
                                                        onClick={updateCheckBox}
                                                        checked={Speed}
                                                        id="Speed"
                                                    />
                                                </Col>
                                            </Row>
                                        )}
                                        <Row>
                                            <Col>
                                                <Form.Check
                                                    inline
                                                    label={props.intl.formatMessage({
                                                        id:
                                                            'components.Modals.Form.Config.Notif.Branchement',
                                                    })}
                                                    disabled={radioDisabled}
                                                    onClick={updateCheckBox}
                                                    checked={PlugEvent}
                                                    id="PlugEvent"
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Check
                                                    inline
                                                    label={props.intl.formatMessage({
                                                        id:
                                                            'components.Modals.Form.Config.Notif.Debranchement',
                                                    })}
                                                    disabled={radioDisabled}
                                                    onClick={updateCheckBox}
                                                    checked={UnplugEvent}
                                                    id="UnplugEvent"
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Check
                                                    inline
                                                    label={props.intl.formatMessage({
                                                        id:
                                                            'components.Modals.Form.Config.Notif.AdressePerso',
                                                    })}
                                                    id="Geofence"
                                                    onClick={updateCheckBox}
                                                    checked={Geofence}
                                                    disabled={radioDisabled}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Check
                                                    inline
                                                    label={props.intl.formatMessage({
                                                        id:
                                                            'components.Modals.Form.Config.Notif.DepNonAut',
                                                    })}
                                                    disabled={radioDisabled}
                                                    onClick={updateCheckBox}
                                                    checked={UnauthorizedMove}
                                                    id="UnauthorizedMove"
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                ) : props.equipementType === 'BEWHERE' ? (
                                    <Col md="4">
                                        <Row>
                                            <Col>
                                                <Form.Check
                                                    inline
                                                    label={props.intl.formatMessage({
                                                        id:
                                                            'components.Modals.Form.Config.Notif.AdressePerso',
                                                    })}
                                                    id="Geofence"
                                                    onClick={updateCheckBox}
                                                    checked={Geofence}
                                                    disabled={radioDisabled}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Check
                                                    inline
                                                    label={props.intl.formatMessage({
                                                        id:
                                                            'components.Modals.Form.Config.Notif.LowBattery',
                                                    })}
                                                    id="Battery"
                                                    onClick={updateCheckBox}
                                                    checked={Battery}
                                                    disabled={radioDisabled}
                                                />
                                            </Col>
                                            {Battery && (
                                                <Col>
                                                    <Form.Control
                                                        as="select"
                                                        disabled={radioDisabled}
                                                        value={batteryVoltage}
                                                        onChange={(e) => {
                                                            setBatteryVoltage(
                                                                Number(e.target.value)
                                                            );
                                                            handleChange(getChangedItems());
                                                        }}
                                                    >
                                                        {voltagesoptionsGeoMobile.map((value) => (
                                                            <option value={value[1]} key={value[1]}>
                                                                {value[0]} V
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                </Col>
                                            )}
                                        </Row>
                                    </Col>
                                ) : (
                                    <React.Fragment>
                                        <Col md="4">
                                            <Row>
                                                <Col>
                                                    <Form.Check
                                                        inline
                                                        label={props.intl.formatMessage({
                                                            id:
                                                                'components.Modals.Form.Config.Notif.alertVol',
                                                        })}
                                                        disabled={radioDisabled}
                                                        onClick={updateCheckBox}
                                                        checked={Stolen}
                                                        id="Stolen"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Check
                                                        inline
                                                        label={props.intl.formatMessage({
                                                            id:
                                                                'components.Modals.Form.Config.Notif.finAlertVol',
                                                        })}
                                                        disabled={radioDisabled}
                                                        onClick={updateCheckBox}
                                                        checked={StolenEnd}
                                                        id="StolenEnd"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Check
                                                        inline
                                                        label={props.intl.formatMessage({
                                                            id:
                                                                'components.Modals.Form.Config.Notif.RalProlong',
                                                        })}
                                                        disabled={radioDisabled}
                                                        onClick={updateCheckBox}
                                                        checked={MotorIdle}
                                                        id="MotorIdle"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Check
                                                        inline
                                                        label={props.intl.formatMessage({
                                                            id:
                                                                'components.Modals.Form.Config.Notif.Accel',
                                                        })}
                                                        id="Accelerometer"
                                                        onClick={updateCheckBox}
                                                        checked={Accelerometer}
                                                        disabled={radioDisabled}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Check
                                                        inline
                                                        label={props.intl.formatMessage({
                                                            id:
                                                                'components.Modals.Form.Config.Notif.Arret',
                                                        })}
                                                        disabled={radioDisabled}
                                                        onClick={updateCheckBox}
                                                        checked={KeyOff}
                                                        id="KeyOff"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Check
                                                        inline
                                                        label={props.intl.formatMessage({
                                                            id:
                                                                'components.Modals.Form.Config.Notif.BtnPouss',
                                                        })}
                                                        disabled={radioDisabled}
                                                        onClick={updateCheckBox}
                                                        checked={Button}
                                                        id="Button"
                                                    />
                                                </Col>
                                            </Row>
                                            {(sendEventOnAux1 ||
                                                sendEventOnAux2 ||
                                                sendEventOnAux3 ||
                                                sendEventOnAux4) && (
                                                <Row>
                                                    <Col>
                                                        <NotifCourriel.SubHeaderTitle
                                                            disabled={radioDisabled}
                                                        >
                                                            <FormattedMessage
                                                                id={
                                                                    'components.Modals.Form.Config.Notif.Aux'
                                                                }
                                                            />
                                                        </NotifCourriel.SubHeaderTitle>
                                                        <AsyncSelect
                                                            isMulti
                                                            isDisabled={radioDisabled}
                                                            value={selectedOptionaux}
                                                            onChange={handleChangeaux}
                                                            options={auxoptions}
                                                            closeMenuOnSelect={false}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                        </Col>
                                        <Col md="4">
                                            <Row>
                                                <Col>
                                                    <Form.Check
                                                        inline
                                                        label={props.intl.formatMessage({
                                                            id:
                                                                'components.Modals.Form.Config.Notif.DepNonAut',
                                                        })}
                                                        disabled={radioDisabled}
                                                        onClick={updateCheckBox}
                                                        checked={UnauthorizedMove}
                                                        id="UnauthorizedMove"
                                                    />
                                                </Col>
                                            </Row>
                                            {speedDetectionEnabled && (
                                                <Row>
                                                    <Col>
                                                        <Form.Check
                                                            inline
                                                            label={props.intl.formatMessage({
                                                                id:
                                                                    'components.Modals.Form.Config.Notif.DepVitesse',
                                                            })}
                                                            disabled={radioDisabled}
                                                            onClick={updateCheckBox}
                                                            checked={Speed}
                                                            id="Speed"
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                            <Row>
                                                <Col>
                                                    <Form.Check
                                                        inline
                                                        label={props.intl.formatMessage({
                                                            id:
                                                                'components.Modals.Form.Config.Notif.AdressePerso',
                                                        })}
                                                        id="Geofence"
                                                        onClick={updateCheckBox}
                                                        checked={Geofence}
                                                        disabled={radioDisabled}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md="12">
                                                    <Form.Check
                                                        inline
                                                        label={props.intl.formatMessage({
                                                            id:
                                                                'components.Modals.Form.Config.Notif.LowBattery',
                                                        })}
                                                        id="Battery"
                                                        onClick={updateCheckBox}
                                                        checked={Battery}
                                                        disabled={radioDisabled}
                                                    />
                                                </Col>
                                                {Battery && (
                                                    <Col>
                                                        <Form.Control
                                                            as="select"
                                                            disabled={radioDisabled}
                                                            value={batteryVoltage}
                                                            onChange={(e) => {
                                                                setBatteryVoltage(
                                                                    Number(e.target.value)
                                                                );
                                                                handleChange(getChangedItems());
                                                            }}
                                                        >
                                                            {voltagesoptions.map((value) => (
                                                                <option
                                                                    value={value[1]}
                                                                    key={value[1]}
                                                                >
                                                                    {value[0]} V
                                                                </option>
                                                            ))}
                                                        </Form.Control>
                                                    </Col>
                                                )}
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Check
                                                        inline
                                                        label={props.intl.formatMessage({
                                                            id:
                                                                'components.Modals.Form.Config.Notif.Demarrage',
                                                        })}
                                                        id="KeyOn"
                                                        onClick={updateCheckBox}
                                                        checked={KeyOn}
                                                        disabled={radioDisabled}
                                                    />
                                                </Col>
                                            </Row>
                                            {(aux2Enabled || aux3Enabled || aux4Enabled) && (
                                                <Row>
                                                    <Col>
                                                        <NotifCourriel.SubHeaderTitle
                                                            disabled={radioDisabled}
                                                        >
                                                            <FormattedMessage
                                                                id={
                                                                    'components.Modals.Form.Config.Notif.Temp'
                                                                }
                                                            />
                                                        </NotifCourriel.SubHeaderTitle>
                                                        <AsyncSelect
                                                            isMulti
                                                            isDisabled={radioDisabled}
                                                            value={selectedOptiontemp}
                                                            onChange={handleChangetemp}
                                                            options={tempoptions}
                                                            closeMenuOnSelect={false}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                        </Col>
                                    </React.Fragment>
                                )}
                            </Row>
                        ) : (
                            <Alert variant="info">
                                <p>
                                    <FormattedMessage
                                        id={'components.Modals.Form.Config.Notif.NoEmail'}
                                    />
                                </p>
                            </Alert>
                        )}
                    </Container>
                </React.Fragment>
            ) : null}
        </Grid>
    );
}
// MAP STATE/DISPATCH
const mapStateToProps: Object = createStructuredSelector({
    emails: selectEmailsRecords(),
    notifRecords: selectEmailNotifConfigRecords(),
    loading: selectEmailsLoading(),
    user: selectUser(),
    saveConfig: selectSaveConfig(),
});
const mapDispatchToProps: Object = (dispatch) =>
    bindActionCreators(
        {
            getEmailsByBranchId,
            getEmailNotifConfigByEquipementId,
            setNotificationCopy,
            setSavingConfig,
            editNotifCourriel,
        },
        dispatch
    );

// EXPORTS
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(NotificationConfig));
